import { render, staticRenderFns } from "./HubForm.vue?vue&type=template&id=8f412a7c&"
import script from "./HubForm.vue?vue&type=script&lang=js&"
export * from "./HubForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports